module.exports = __webpack_public_path__ + "static/media/ue1.7a81f5f1.png";